import { render, staticRenderFns } from "./threeD.vue?vue&type=template&id=48336676&scoped=true"
import script from "./threeD.vue?vue&type=script&lang=js"
export * from "./threeD.vue?vue&type=script&lang=js"
import style0 from "./threeD.vue?vue&type=style&index=0&id=48336676&prod&lang=scss&scoped=true"
import style1 from "./threeD.vue?vue&type=style&index=1&id=48336676&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48336676",
  null
  
)

export default component.exports